import { IApplicationState } from 'shared/types/redux';

export const selectShortFormGroup = (state: IApplicationState) => state.landing.shortFormGroup;
